import { useState } from "react";
import { message } from "antd";
import { putTranscriptionSettings } from "../service";
import InputComponent from "V2.0/components/InputComponent";
import { Button } from "V2.0/common/button";

export default function BoostKeywords(props) {
  const {
    transcriptionSettings,
    syncAssistant,
    workspaceId,
    assistantId,
    locked,
  } = props;

  const [settings, setSettings] = useState({
    keywordsToBoost: transcriptionSettings?.deepgramSettings?.keywordsToBoost,
  });

  function handleUpdate(keywordsToBoost) {
    setSettings({
      keywordsToBoost,
    });
  }

  async function handleSave() {
    message.loading("Updating Keywords");
    const payload = {
      deepgramSettings: settings,
    };

    try {
      const response = await putTranscriptionSettings({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Keywords updated");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            transcriptionSettings: response.data,
          };
        });
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to update keywords"
      );
    }
  }

  return (
    <div className="flex flex-col border rounded-lg w-3/5 min-w-[600px] m-4">
      <div className="p-4 bg-gray-50 rounded-t-lg px-6">
        <p className="text-base font-semibold text-gray-900">Boost Keywords</p>
        <p className="text-sm mt-1 text-gray-500">
          Add important words so the assistant won’t get confused by words that
          sound alike
        </p>
      </div>
      <div className="grid grid-cols-4 p-4 px-8 w-full">
        <div className="col-span-4 w-full">
          <InputComponent
            type="textArea"
            style={{ height: "100px", fontSize: "13px" }}
            label="Enter Keywords (comma-seperated)"
            value={settings.keywordsToBoost}
            onChange={(e) => handleUpdate(e.target.value)}
            disabled={locked}
          />
        </div>
      </div>
      <div className="bg-gray-50 rounded-b-lg px-4 py-3 text-right">
        {!locked && <Button onClick={handleSave}>Save</Button>}
      </div>
    </div>
  );
}
